import styled from '@emotion/styled'
import {
  Divider,
  IconButton as MuiIconButton,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material'
import { spacing } from '@mui/system'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'
import useLoggedInUser from '@/hooks/useLoggedInUser'
import useT from '@/i18n/useT'

import { UserAvatarWithQuery } from '../users/UserAvatarWithQuery'

const IconButton = styled(MuiIconButton)`
  ${spacing};

  &:hover {
    background-color: transparent;
  }
`

function NavbarUserDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null)
  const navigate = useNavigate()
  const { signOut } = useAuth()
  const { user } = useLoggedInUser('cache-first')
  const { t } = useT()

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget)
  }

  const closeMenu = () => {
    setAnchorMenu(null)
  }

  const handleSignOut = async () => {
    await signOut()
    navigate('/auth/sign-in')
  }

  const handleGoToProfile = () => {
    navigate('/admin/profile')
    closeMenu()
  }

  return (
    <>
      <Tooltip title={t('navbarUserDropdown.account')}>
        <IconButton
          aria-owns={anchorMenu ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
        >
          {!!user && <UserAvatarWithQuery id={user.id} />}
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <MenuItem onClick={handleGoToProfile}>
          {t('navbarUserDropdown.profileAndSettings')}
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleSignOut}>
          {t('navbarUserDropdown.signOut')}
        </MenuItem>
      </Menu>
    </>
  )
}

export default NavbarUserDropdown
